import indirection from './indirection.png'

const content = `<p>An Indirection consists in introducing a component between two components A and B:</p>

<img src=${indirection} alt="indirection" />

<p>This new component reduces the coupling between A and B as they no longer have to know about each other.</p>

<p>A typical example of indirection is the <a href="/adapter">Adapter</a> pattern.</p>`

export default content
